import React, { useEffect, useState, useRef } from "react";
import customerimg1 from "../../images/Frame.svg";
import Document from "../../images/Doc.png";
import Booking from "../../images/booking.png";
import Billing from "../../images/Billing.png";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import CryptoJS from "crypto-js";
import "./ClientDocuments.css";
import Loader from "../../components/Loader/loader";
import { useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

const ClientDocuments = () => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [open, setOpen] = useState(false);
  const [reloadFlag, setReloadFlag] = useState(false);
  const [activeBtn, setActiveBtn] = useState("documentation");

  const [firstItem, setFirstItem] = useState({
    client_doc_id: "",
    relocation_id: "",
    document_type: "",
    remarkDoc: "",
    doc_path: "",
    doc_name: "",
    priority_upload: "3",
  });
  const [documentResponse, setDocumentResponse] = useState([0]);
  const [documentType, setDocumentType] = useState([]);
  const [rel, setRel] = useState("");
  const [data, setData] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [leadOwner, setLeadOwner] = useState("");
  // Navbar
  const drawerWidth = 240;

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const encryptedEmailID = searchParams.get("Email");

    if (!encryptedRelocationID || !encryptedEmailID) {
      console.error("Missing URL parameters");
      return;
    }

    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    const Email_ID = decryptRelocationID(encryptedEmailID);
    setRel(Relocation_ID);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    Promise.all([
      axios.get(
        `${baseAPI}customer/GetClientDocuments?relocation_id=${Relocation_ID}&option=1&email_id=${Email_ID}`,
      ),
      axios.get(
        `${baseAPI}customer/GetDocumentType?relocation_id=${Relocation_ID}`,
      ),
    ])
      .then(([docRes, typeRes]) => {
        if (docRes) {
          const documents = docRes.data.data;
          setDocumentResponse(documents);
          setData(true);
          if (documents.length > 0) {
            const first = documents[0];
            setCustomerName(first.CustomerName);
            setLeadOwner(first.LeadOwner);
          }
        }
        if (typeRes) {
          setDocumentType(typeRes.data.data.map((Name) => ({ Name })));
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [reloadFlag]);

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
      "application/vnd.ms-excel", // XLS
      "video/mp4",
      "video/x-msvideo", // AVI
      "video/x-matroska", // MKV
      "video/quicktime", // MOV
    ];
    return file && allowedTypes.includes(file.type);
  }
  function getUpdatedImage(file, name) {
    if (file) {
      setFirstItem({
        ...firstItem,
        [name]: file, // Store the file object directly
      });
    }
  }

  function handleChange(e) {
    const { name, value, files } = e.target;

    if (name === "doc_name") {
      const file = files[0];
      if (file.size > 50 * 1024 * 1024) {
        alert("File size exceeds 50 MB limit.");
        e.target.value = null;
        return;
      }

      if (isValidFileType(file)) {
        getUpdatedImage(file, name);
      } else {
        alert("Unsupported file type. Please upload a valid file.");
        // Reset the file input field
        e.target.value = null;
        return;
      }
    } else {
      setFirstItem({
        ...firstItem,
        [name]: value,
      });
    }
  }

  function decryptRelocationID(ciphertext) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(ciphertext),
        "dbbworldwidepvtltd",
      );
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error decrypting Relocation_ID:", error);

      return null;
    }
  }

  const uploadDocument = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);

    // Append form fields and the file to FormData
    formData.append("relocation_id", Relocation_ID);
    formData.append("document_type", firstItem.document_type);
    formData.append("remarkDoc", firstItem.remarkDoc);
    formData.append("priority_upload", firstItem.priority_upload);

    // Ensure the file itself is being sent
    formData.append("doc_name", firstItem.doc_name);

    try {
      const response = await axios.post(
        `${baseAPI}Customer/UploadClientPdfData`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        // Clear form fields and reset file input
        setFirstItem({
          client_doc_id: "",
          relocation_id: Relocation_ID,
          document_type: "",
          remarkDoc: "",
          doc_path: "",
          doc_name: "",
          priority_upload: "3",
        });

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setReloadFlag((prev) => !prev);
      }
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  };

  async function getDocument(Relocation_ID) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      try {
        const response = await axios.get(
          `${baseAPI}customer/GetClientDocuments?relocation_id=${Relocation_ID}&option=1`,
        );

        if (response && response.data && response.data.data) {
          const documents = response.data.data;
          setDocumentResponse(documents);

          if (documents.length > 0) {
            const first = documents[0];
            setCustomerName(first.CustomerName);
            setLeadOwner(first.LeadOwner);
          }
        }
      } catch (error) {
        console.error("Error fetching user detail:", error);
      }
    }
  }

  async function submitDocument(client_doc_id) {
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    try {
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}customer/SubmitClientDocument`,
        { client_doc_id: client_doc_id },
      );
      setReloadFlag((prev) => !prev);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  }

  async function deleteDoc(client_doc_id) {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this document?",
    );
    const searchParams = new URLSearchParams(location.search);
    const encryptedRelocationID = searchParams.get("Relocation_ID");
    const Relocation_ID = decryptRelocationID(encryptedRelocationID);
    if (isConfirmed) {
      // Make a POST request to your API endpoint
      const response = await axios.delete(
        `${baseAPI}customer/DeleteClientDocs`,
        {
          data: { client_doc_id: client_doc_id }, // Send request body
        },
      );
      setReloadFlag((prev) => !prev);
    }
  }

  function nextPage1(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/BookingForm?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  function billingPage(Relocation_ID) {
    const key = "dbbworldwidepvtltd";
    const encryptedRelocationID = encryptRelocationID(Relocation_ID, key);

    const url = `/billingDetails?Relocation_ID=${encryptedRelocationID}`;
    window.open(url, "_blank");
  }

  function encryptRelocationID(Relocation_ID, key) {
    const ciphertext = CryptoJS.AES.encrypt(
      Relocation_ID.toString(),
      key,
    ).toString();
    return encodeURIComponent(ciphertext);
  }

  return (
    <>
      {!data ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            paddng: "63px",
            padding: "43px",
          }}
          className="row not-authrized-div"
        >
          <h1 className="col-md-12 col-lg-12 col-sm-12">
            Welcome to carry my pet
          </h1>
        </div>
      ) : (
        <>
          {/* CustomerNavber */}
          <Box sx={{ display: "flex" }}>
            <CssBaseline />
            <AppBar position="fixed" open={open}>
              <Toolbar
                sx={{
                  background:
                    "linear-gradient(to right, #F15843, #A3519F, #5B489D)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "end",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    style={{ paddingTop: "1px", cursor: "pointer" }}
                  >
                    {/* <img src={logo} alt="" /> */}
                    {/* <div style={{ width: "100%", height: "43px", paddingRight: "20px" }}>
                      <a onClick={() => billingPage(rel)} style={{ color: "white", textDecoration: "none", textTransform: "uppercase", fontSize: "18px" }}>
                        Add Billing Details
                      </a>
                    </div> */}
                  </Typography>

                  <Typography
                    variant="h6"
                    noWrap
                    component="div"
                    style={{ paddingTop: "1px", cursor: "pointer" }}
                  >
                    {/* <img src={logo} alt="" /> */}
                    <div style={{ width: "100%", height: "43px" }}>
                      <span
                        style={{ textTransform: "uppercase", fontSize: "18px" }}
                      >
                        <b>Lead Id :</b> {rel}
                      </span>
                    </div>
                  </Typography>
                </div>
              </Toolbar>
            </AppBar>

            {/*  */}
          </Box>
          {/* CustomerNavber */}
          {/* <CustomerNavbar /> */}

          {/* <div className="background">
            <div className="image-container row">
              <div className="col-4">
                
                <img src={Document} alt="img" className="customer-image hidden md:block" />
               
                <img
                  src={Document}
                  alt="img"
                  className="customer-image block md:hidden mt-2"
                />
              </div>
               <div className="col-4">
                
                <img src={Document} alt="img" className="customer-image hidden md:block" />
               
                <img
                  src={Document}
                  alt="img"
                  className="customer-image block md:hidden mt-2"
                />
              </div>
              <div className="col-4" onClick={() => nextPage1(rel)} style={{ cursor: "pointer" }}     >
                <img src={Booking} alt="img" className="customer-image hidden md:block" />
                <img
                  src={Booking}
                  alt="img"
                  className="customer-image block md:hidden mt-2"
                />

              </div>
            </div>
          </div> */}
          <div className="background">
            <div className="image-container row">
              {/* Desktop Images */}
              <div className="col-4 desktop-view">
                <img src={Document} alt="img" className="customer-image" />
              </div>

              <div className="col-4 desktop-view"
              onClick={() =>  billingPage(rel)} style={{ cursor: "pointer" }}>
                <img src={Billing} alt="img" className="customer-image" />
              </div>

              <div
                className="col-4 desktop-view"
                onClick={() => nextPage1(rel)}
                style={{ cursor: "pointer" }}
              >
                <img src={Booking} alt="img" className="customer-image" />
              </div>

              {/* Mobile Buttons */}
              <div className="col-12 mobile-view">
                <div
                  className={`mobile-btn ${activeBtn === "documentation" ? "active" : ""}`}
                  onClick={() => setActiveBtn("documentation")}
                >
                  📄 Documentation 
                  {/* <span>→</span> */}
                </div>

                <div
                  className={`mobile-btn ${activeBtn === "booking" ? "active" : ""}`}
                  onClick={() => {
                    setActiveBtn("booking");
                    nextPage1(rel);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  📝 Booking Form <span>&rarr;</span>
                </div>

                <div
                  className={`mobile-btn ${activeBtn === "billing" ? "active" : ""}`}
                  onClick={() => {
                    setActiveBtn("billing");
                    billingPage(rel);
                  }}
                >
                  💳 Billing Details <span>→</span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="sscroll customer-docbody">
              <Wrapper className="orderlist upload-document_orderlist">
                <div className="content-container-orderlist">
                  <div
                    className="container-fluid upload-document_container_f"
                    style={{ backgroundColor: "#ffffff", borderRadius: "12px" }}
                  >
                    <div className="customer-docbody-upload">
                      <div
                        className="order-summary-header"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <h3 className="order-summary-title">
                          Upload Document{" "}
                        </h3>
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <div className="row mb-3">
                            {/* Document Type */}
                            <div className="col-12 col-md-6 mb-2 mb-md-0">
                              <label
                                className="font-12"
                                htmlFor="document_type"
                              >
                                Document Type
                              </label>
                              <select
                                id="document_type"
                                className="form-control font-14"
                                name="document_type"
                                onChange={handleChange}
                                value={firstItem.document_type}
                                style={{ margin: "7px" }}
                              >
                                <option value="0">Select an option</option>
                                {documentType.map((item) => (
                                  <option key={item}>{item.Name}</option>
                                ))}
                              </select>
                            </div>
                            {/* Choose Document */}
                            <div className="col-12 col-md-6 mb-2 mb-md-0">
                              <label className="font-12" htmlFor="doc_name">
                                Choose Document
                              </label>
                              <input
                                id="doc_name font-14"
                                type="file"
                                name="doc_name"
                                onChange={handleChange}
                                ref={fileInputRef}
                                required
                                className="form-control"
                                style={{ padding: "6px" }}
                              />
                            </div>

                            {/* Remark */}
                            <div className="col-12 col-md-12 mb-2 mb-md-0 Any-Remark">
                              <label className="font-12" htmlFor="remarkDoc">
                                Any Remark
                              </label>
                              <input
                                id="remarkDoc"
                                type="text"
                                name="remarkDoc"
                                onChange={handleChange}
                                value={firstItem.remarkDoc}
                                placeholder="Write.."
                                className="form-control font-14"
                                style={{ height: "38px" }}
                              />
                            </div>
                            <div
                              className="col-12 col-md-12 mb-3 mb-md-0"
                              style={{ padding: "0 11px 0 21px" }}
                            >
                              <p
                                className="font-10"
                                style={{ color: "red", textAlign: "justify" }}
                              >
                                Note: Once documents are uploaded and submitted,
                                they cannot be deleted and will be visible to
                                all users. Please ensure you review the content
                                carefully before submitting.
                              </p>
                            </div>

                            {/* Upload Button */}
                            <div className="col-12 col-md-3 ms-auto text-end">
                              <button
                                style={{
                                  backgroundColor: "#5B489D",
                                  color: "white",
                                }}
                                className="btn btn-success w-50  c-docUpload mobile-c-docUpload"
                                onClick={uploadDocument}
                              >
                                Upload
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Wrapper>
              <br></br>
              <Wrapper className="orderlist upload-document_orderlist">
                <div className="content-container-orderlist">
                  <div
                    className="container-fluid upload-document_container_f"
                    style={{ backgroundColor: "#ffffff", borderRadius: "12px" }}
                  >
                    <div className="customer-docbody-upload">
                      <div
                        className="order-summary-header table-summary-header"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <h3 className="order-summary-title">Documents</h3>
                      </div>
                      <div className="mobile-view_customer-pro">
                        <table className="responsiveTable desktop-view-hide_code">
                          <thead>
                            <tr className="viewLeadDetailsHeading">
                              <th style={{ background: "#EBEBEB" }}>
                                <span>Customer Name:</span>
                              </th>
                              <td className="viewLeadDetailsHeading_mukul-th">
                                <span>{customerName}</span>
                              </td>
                              <th style={{ background: "#EBEBEB" }}>
                                <span>Lead Owner:</span>
                              </th>
                              <td className="viewLeadDetailsHeading_mukul-th">
                                <span>{leadOwner}</span>
                              </td>
                            </tr>
                          </thead>
                        </table>
<div className="mobile-view-hide_code">
  <div className="row">
                          <div className="col-5 font-14"><span>Customer Name:</span></div>
                          <div className="col-5 font-14"> <span style={{color: "black", fontWeight: 700}}>{customerName}</span></div>
                        </div>
                        <div className="row">
                          <div className="col-5 font-14"><span>Lead Owner:</span></div>
                          <div className="col-5 font-14">  <span style={{color: "black", fontWeight: 700}}>{leadOwner}</span></div>
                        </div>
</div>
                        

                        <div className="row mt-4">
                          {/* Mobile view */}
                          {isMobile ? (
                            <div className="mukul-table-s">
                              {loading ? (
                                <div
                                  style={{
                                    textAlign: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <Loader />
                                </div>
                              ) : (
                                <div className="col-12 mukul-table-s-col">
                                  <div className="overflowDiv">
                                    {documentResponse !== null ? (
                                      documentResponse.map((item, index) => (
                                        <div
                                          className="mobile-card"
                                          key={item.client_doc_id}
                                        >
                                          {/* Date & Time */}
                                          <div className="mobile-card-header">
                                            <span>
                                              <strong className="label-color">
                                                Date :
                                              </strong>{" "}
                                              {new Date(
                                                item.created_date,
                                              ).toLocaleDateString("en-GB", {
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                              })}
                                            </span>

                                            <span>
                                              <strong className="label-color">
                                                Time :
                                              </strong>{" "}
                                              {new Date(
                                                item.created_date,
                                              ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                            </span>
                                          </div>

                                          <hr />

                                          {/* Document Title */}
                                          <h6 className="mobile-doc-title">
                                            {index + 1}. {item.document_type}
                                          </h6>

                                          {/* Remark */}
                                          <p className="mobile-remark">
                                            <strong>Remark :</strong>{" "}
                                            {item.remarkDoc}
                                          </p>

                                          {/* Buttons Section */}
                                          <div className="mobile-btn-group">
                                            {/* Delete Button (Only if not submitted) */}
                                            {item.isSubmit === 0 && (
                                              <button
                                                onClick={() =>
                                                  deleteDoc(item.client_doc_id)
                                                }
                                                className="mobile-delete-btn"
                                              >
                                                🗑
                                              </button>
                                            )}

                                            {/* View Button */}
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                                              download={`${item.doc_name}`}
                                              className="mobile-view-btn"
                                            >
                                              View
                                            </a>

                                            {/* Submit / Submitted Button */}
                                            {item.isSubmit === 0 ? (
                                              <button
                                                className="mobile-submit-btn"
                                                onClick={() =>
                                                  submitDocument(
                                                    item.client_doc_id,
                                                  )
                                                }
                                              >
                                                Submit
                                              </button>
                                            ) : (
                                              <button
                                                className="mobile-submitted-btn"
                                                disabled
                                              >
                                                Submitted
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <p style={{ textAlign: "center" }}>
                                        No documents available.
                                      </p>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            /* Desktop view */
                            <div
                              style={{ width: "100%", alignItems: "center" }}
                            >
                              <table
                                className="customerDetailsTable"
                                style={{ width: "100%" }}
                              >
                                <div
                                  className=" undefined"
                                  style={{ width: "100%" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      style={{
                                        // padding: "11px 0 0 0",
                                        height: "230px",
                                        overflowX: "auto",
                                      }}
                                    >
                                      {loading ? (
                                        <div
                                          style={{
                                            position: "relative",
                                            left: "540px",
                                          }}
                                        >
                                          <Loader />
                                        </div>
                                      ) : (
                                        <table>
                                          <tr style={{ background: "#EBEBEB" }}>
                                            <th>Sr No.</th>
                                            <th>Document Type</th>
                                            <th>Upload Date & Time</th>
                                            <th>Remark</th>
                                            <th>Review</th>
                                            <th>Submit</th>
                                          </tr>
                                          <div style={{ height: "6px" }}></div>
                                          {documentResponse !== null
                                            ? documentResponse.map(
                                                (item, index) => (
                                                  <tr
                                                    className={`documentTable ${
                                                      index % 2 === 0
                                                        ? "evenRow"
                                                        : "oddRow"
                                                    }`}
                                                    key={item.client_doc_id}
                                                  >
                                                    <td style={{ width: "5%" }}>
                                                      {++index}
                                                    </td>

                                                    <td
                                                      style={{ width: "20%" }}
                                                    >
                                                      {item.document_type}
                                                    </td>
                                                    <td
                                                      style={{ width: "20%" }}
                                                    >
                                                      {new Intl.DateTimeFormat(
                                                        "en-GB",
                                                        {
                                                          day: "2-digit",
                                                          month: "short",
                                                          year: "numeric",
                                                          hour: "2-digit",
                                                          minute: "2-digit",
                                                          hour12: true,
                                                        },
                                                      ).format(
                                                        new Date(
                                                          item.created_date,
                                                        ),
                                                      )}
                                                    </td>
                                                    <td
                                                      style={{ width: "20%" }}
                                                    >
                                                      {item.remarkDoc}
                                                    </td>

                                                    <td
                                                      style={{
                                                        width: "20%",
                                                        paddingLeft: "23px",
                                                      }}
                                                    >
                                                      <a
                                                        style={{
                                                          color: "#6a6a6a",
                                                          textDecoration:
                                                            "none",
                                                          cursor: "pointer",
                                                          fontWeight: "bold",
                                                        }}
                                                        target="blank"
                                                        href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.doc_name}`}
                                                        download={`${baseImageURL}${item.doc_path}`}
                                                        rel="noopener noreferrer"
                                                      >
                                                        <SearchIcon />
                                                      </a>
                                                      {item.isSubmit === 0 ? (
                                                        <button
                                                          onClick={() =>
                                                            deleteDoc(
                                                              item.client_doc_id,
                                                            )
                                                          }
                                                          style={{
                                                            height: "35px",
                                                            width: "35px",
                                                            marginLeft: "5px",
                                                            backgroundColor:
                                                              "#F4616F",
                                                            borderColor:
                                                              "#FF0000",
                                                            borderRadius:
                                                              "10px",
                                                            padding: "3px",
                                                          }}
                                                        >
                                                          <DeleteOutlinedIcon className="icon" />
                                                        </button>
                                                      ) : null}
                                                    </td>

                                                    <td>
                                                      {item.isSubmit === 0 ? (
                                                        <button
                                                          style={{
                                                            backgroundColor:
                                                              "#5B489D",
                                                            color: "white",
                                                            width: "82%",
                                                            margin: "7px",
                                                          }}
                                                          className="btn btn-success inputDoc3"
                                                          onClick={() =>
                                                            submitDocument(
                                                              item.client_doc_id,
                                                            )
                                                          }
                                                        >
                                                          Submit
                                                        </button>
                                                      ) : (
                                                        <button
                                                          style={{
                                                            backgroundColor:
                                                              "#40e048ff",
                                                            color: "white",
                                                            width: "82%",
                                                            margin: "7px",
                                                          }}
                                                          className="btn btn-success inputDoc3"
                                                        >
                                                          Submitted
                                                        </button>
                                                      )}
                                                    </td>
                                                  </tr>
                                                ),
                                              )
                                            : null}
                                        </table>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>
          </div>
        </>
      )}
      <style jsx>{`
     
        /* Card Container */
        .mobile-card {
          border: 2px solid #2d7ef8;
          border-radius: 10px;
          padding: 15px;
          margin-bottom: 15px;
          background-color: #f9f9f9;
        }

        /* Header Row */
        .mobile-card-header {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          margin-bottom: 8px;
        }

        .label-color {
          color: #f4616f;
        }

        /* Document Title */
        .mobile-doc-title {
          color: #5b489d;
          font-weight: 700;
          margin-top: 10px;
          margin-bottom: 8px;
        }

        /* Remark */
        .mobile-remark {
          color: #6a6a6a;
          font-size: 14px;
          margin-bottom: 15px;
        }

        /* Buttons Group */
        .mobile-btn-group {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        /* Delete Button */
        .mobile-delete-btn {
          background-color: #f4616f;
          border: none;
          color: white;
          padding: 6px 10px;
          border-radius: 8px;
          font-size: 14px;
        }

        /* View Button */
        .mobile-view-btn {
          flex: 1;
          border: 2px solid #5b489d;
          color: #5b489d;
          background: white;
          text-align: center;
          padding: 6px;
          border-radius: 8px;
          font-weight: 600;
          text-decoration: none;
        }

        /* Submit Button */
        .mobile-submit-btn {
          flex: 1;
          background-color: #5b489d;
          color: white;
          border: none;
          padding: 6px;
          border-radius: 8px;
          font-weight: 600;
        }

        /* Submitted Button */
        .mobile-submitted-btn {
          flex: 1;
          background-color: #5b489d;
          color: white;
          border: none;
          padding: 6px;
          border-radius: 8px;
          font-weight: 600;
        }
/* Hide on Desktop */
@media (min-width: 768px) {
  .mobile-view-hide_code {
    display: none;
  }
}
        @media (max-width: 576px) {

        .mobile-c-docUpload{
        margin-bottom: 17px;
        }

        .desktop-view-hide_code{
        display: none;
        }
          .font-14 {
            font-size: 14px !important;
          }
          .font-12 {
            font-size: 12px !important;
          }
          .font-10 {
            font-size: 10px !important;
          }
          .order-summary-title {
            font-weight: 600;
            padding: 8px 8px 0px 12px;
            font-size: 16px;
          }
        }
        .mobile-btn {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f5f5f5;
          padding: 14px 16px;
          border-radius: 10px;
          margin-bottom: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .mobile-btn.active {
          border: 1px solid #5b489d;
          // color: white;
        }

        .mobile-btn.active span {
          // background: white;
          color: #fff;
          padding: 4px 8px;
          border-radius: 50%;
        }

        /* Default: Desktop */

        .desktop-view {
          display: block;
        }

        .mobile-view {
          display: none;
          padding: 14px;
        }

        /* Mobile View */
        @media (max-width: 768px) {
          .viewLeadDetailsHeading_mukul-th {
            margin-bottom: 15px;
          }

          .mukul-table-s {
            padding: 0px;
          }
          .mukul-table-s-col {
            padding: 0px;
          }
          .wrapper {
            box-shadow: none;
          }
          .mobile-view_customer-pro {
            padding: 0px 12px 12px 12px;
          }
          .viewLeadDetailsHeading th {
            // background-color: #F8F9FA;
            border-radius: 3px;
            margin-bottom: 12px;
            margin-top: 12px;
          }
          .upload-document_orderlist {
            padding: 0px 14px;
          }
          .upload-document_container_f {
            padding: 0px;
          }
          .customer-docbody-upload {
            padding: 0px 0 0 0;
          }
          .order-summary-header {
            border-radius: 4px 4px 0 0;
            margin-bottom: 25px;
          }
          .mobile-btn span {
            background: #6f42c1;
            width: 32px;
            border-radius: 19px;
            height: 32px;
            padding: 2px 0px 5px 8px;
            color: white;
          }
          .desktop-view {
            display: none;
          }

          .mobile-view {
            display: block;
          }

          .mobile-btn {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f5f5f5;
            padding: 14px 16px;
            border-radius: 10px;
            margin-bottom: 12px;
            font-weight: 500;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
            cursor: pointer;
          }
        }
      `}</style>
    </>
  );
};

export default ClientDocuments;
